import DistrictsProvider from "providers/DistrictsProvider"
import DistrictsTamplate from "components/templates/DistrictsTemplate"

const Districts = () => {
  return (
      <DistrictsProvider>
        <DistrictsTamplate />
      </DistrictsProvider>
  )
}

export default Districts

